// extracted by mini-css-extract-plugin
export default {"fs":"_575e8edb76 _44b7ed231a"};